"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = require("react");

const styles_1 = require("./styles");

const hooks_1 = require("../../hooks");

const Divider_1 = __importDefault(require("../Divider"));

const Logo_1 = __importDefault(require("../Logo"));

const SideMenuIcon_1 = __importDefault(require("../Icons/SideMenuIcon"));

const BetaTag_1 = __importDefault(require("../BetaTag"));

const SideMenu = props => {
  const {
    children,
    onCollapse = () => {},
    initialIsCollapsed = false,
    isToggleDisabled,
    logoHref,
    logoTarget,
    showBetaTag
  } = props;
  const [isCollapsed, setIsCollapsedOpen] = (0, react_1.useState)(initialIsCollapsed);
  const [isHidden, setIsHidden] = (0, react_1.useState)(initialIsCollapsed);
  const contentRef = (0, react_1.useRef)(null);
  const {
    overflowY
  } = (0, hooks_1.useElementOverflow)(contentRef);

  const onCollapseToggle = e => {
    if (isToggleDisabled) {
      return;
    }

    e.currentTarget.blur();
    setIsCollapsedOpen(!isCollapsed);
    onCollapse(!isCollapsed);
    setIsHidden(false);
  };

  const onTransitionEnd = () => {
    if (isCollapsed) {
      setIsHidden(true);
    }
  };

  (0, react_1.useEffect)(() => {
    if (typeof props.isCollapsed === 'boolean') {
      setIsCollapsedOpen(props.isCollapsed);
      onCollapse(props.isCollapsed);
      setIsHidden(false);
    }
  }, [props.isCollapsed]);
  return (0, jsx_runtime_1.jsx)(styles_1.DrawerWrapper, Object.assign({
    isCollapsed: isCollapsed
  }, {
    children: (0, jsx_runtime_1.jsxs)(styles_1.DrawerContainer, Object.assign({
      isCollapsed: isCollapsed,
      onTransitionEnd: onTransitionEnd
    }, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.ToggleButton, Object.assign({
        isCollapsed: isCollapsed,
        onClick: onCollapseToggle,
        isDisabled: isToggleDisabled,
        disabled: isToggleDisabled
      }, {
        children: (0, jsx_runtime_1.jsx)(SideMenuIcon_1.default, {}, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)(styles_1.HeaderContainer, Object.assign({
        isCollapsed: isCollapsed,
        isHidden: isHidden,
        "aria-hidden": isCollapsed
      }, {
        children: (0, jsx_runtime_1.jsx)(styles_1.LogoWrapper, Object.assign({
          href: logoHref,
          target: logoTarget
        }, {
          children: (0, jsx_runtime_1.jsxs)("div", Object.assign({
            style: {
              position: 'relative'
            }
          }, {
            children: [(0, jsx_runtime_1.jsx)(Logo_1.default, {}, void 0), showBetaTag && (0, jsx_runtime_1.jsx)(BetaTag_1.default, {}, void 0)]
          }), void 0)
        }), void 0)
      }), void 0), (0, jsx_runtime_1.jsx)(Divider_1.default, {}, void 0), children && (0, jsx_runtime_1.jsx)(styles_1.ContentContainer, Object.assign({
        ref: contentRef,
        isCollapsed: isCollapsed,
        isHidden: isHidden,
        overflowY: overflowY,
        "aria-hidden": isCollapsed
      }, {
        children: children
      }), void 0)]
    }), void 0)
  }), void 0);
};

exports.default = SideMenu;